/**
 * @fileoverview The musical-interest suggestion list, shared by the student
 * invite (portal claim) step and the instructor's student edit form.
 *
 * ONE list, mirrored in `mobile/src/screens/StudentDetailScreen.js`
 * (`INTEREST_SUGGESTIONS`) so a student tagged on one client matches the same
 * student tagged on the other. Suggestions only — an interest is stored as the
 * free text that was entered, so the label IS the identity, and both clients
 * let the typist add anything not on the list.
 */

export const INTEREST_OPTIONS = [
  "Classical", "Jazz", "Pop", "Rock", "Blues", "Folk", "Country",
  "R&B", "Hip-Hop", "Electronic", "Musical Theater", "Improvisation",
  "Sight-Reading", "Ear Training", "Songwriting", "Film Scoring",
  "World Music", "Metal", "Funk", "Soul",
];
